<div class="modal-header">
    <h1 id="title" class="font-weight-bold">
        {{ "COMPETENCE_MODAL_TITLE" | translate }}
    </h1>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-spinner
        [overlay]="true"
        [overlayRounded]="true"
        [visible]="!unassignedTask || isLoading"
    ></app-spinner>
    @if (unassignedTask) {
        <h2>
            {{ unassignedTask.serviceName }}
        </h2>
    }
    <span class="font-weight-bold modal-lg competence-change">
    {{ originalSkillLevelDescription | async }} &rarr; {{ newSkillLevelDescription | async }}
  </span>
    <div class="w-100 mt-5 d-flex justify-content-around">
        <button class="btn admin-task-modal-btn btn-primary mr-4"
                type="button"
                translate="COMPETENCE_UPDATE_ONE"
                (click)="updateOneClicked()"
        ></button>
        @if (unassignedTask && unassignedTask.numberOfEmployees > 1) {
            <button class="btn admin-task-modal-btn btn-primary mr-4"
                    type="button"
                    translate="COMPETENCE_UPDATE_ALL"
                    (click)="updateAllClicked()"
            ></button>
        }
    </div>
</div>
